export type Role = 'SYS_ADMIN' | 'USER';

export const dv = {
  appName: 'ވެޕްޑޮކްސް',
  common: {
    save: 'ސޭވްކުރޭ', cancel: 'ކެންސަލް', edit: 'އެޑިޓްކުރޭ', delete: 'ޑިލީޓްކުރޭ',
    loading: 'ލޯޑްވަނީ…', back: 'އަނބުރާ', close: 'ބަންދުކުރޭ', submit: 'ހުށަހަޅާ',
    download: 'ޑައުންލޯޑް', downloading: 'ޑައުންލޯޑްވަނީ…', error: 'މައްސަލައެއް ދިމާވެއްޖެ. އަލުން މަސައްކަތްކޮށްލައްވާ',
    required: 'މި ފީލްޑް ފުރިހަމަކުރައްވާ', none: 'ނެތް', confirm: 'ޔަގީންކުރޭ', retry: 'އަލުން މަސައްކަތްކުރޭ',
    active: 'އެކްޓިވް', inactive: 'ޑީއެކްޓިވޭޓްކޮށްފައި', suspended: 'ސަސްޕެންޑްކޮށްފައި',
    page: 'ޞަފްޙާ', next: 'ކުރިއަށް', prev: 'ފަހަތަށް',
  },
  auth: {
    login: 'ވަންނަން', email: 'އީމެއިލް', password: 'ޕާސްވޯޑް',
    forgotPassword: 'ޕާސްވޯޑް ހަނދާން ނެތުނީތަ؟',
    resetPassword: 'ޕާސްވޯޑް ބަދަލުކުރޭ', newPassword: 'އައު ޕާސްވޯޑް',
    confirmPassword: 'ޕާސްވޯޑް ޔަގީންކުރޭ', passwordMismatch: 'ދެ ޕާސްވޯޑް ދިމައެއް ނުވޭ',
    invalidCredentials: 'އީމެއިލް ނުވަތަ ޕާސްވޯޑް ރަނގަޅެއް ނޫން',
    logout: 'ލޮގްއައުޓް', yourName: 'ފުރިހަމަ ނަން',
    acceptInviteTitle: 'އެކައުންޓް ހެދުން', acceptInvite: 'އެކައުންޓް ހަދާ',
    resetSent: 'ޕާސްވޯޑް ބަދަލުކުރާ ލިންކް އީމެއިލްކޮށްފީމެވެ',
    sendResetLink: 'ލިންކް ފޮނުވާ',
    resetLinkExpired: 'މި ލިންކްގެ މުއްދަތު ހަމަވެއްޖެ. އަލުން ލިންކެއް ހޯއްދަވާ',
    profile: 'ޕްރޮފައިލް', changePassword: 'ޕާސްވޯޑް ބަދަލުކުރުން',
    currentPassword: 'މިހާރުގެ ޕާސްވޯޑް', passwordChanged: 'ޕާސްވޯޑް ބަދަލުކޮށްފި',
    saved: 'ސޭވްކޮށްފި',
    showPassword: 'ޕާސްވޯޑް ދައްކާ', hidePassword: 'ޕާސްވޯޑް ފޮރުވާ',
    signingIn: 'ވަންނަނީ…',
    brandTagline: 'ކައުންސިލް ޑޮކިއުމަންޓް',
    handoffInvalid: 'މި ލިންކް ބޭނުން ނުކުރެވޭ ނުވަތަ މުއްދަތު ހަމަވެއްޖެ',
  },
  nav: {
    dashboard: 'ޑޭޝްބޯޑް', users: 'ޔޫޒަރުން',
    orgs: 'ކައުންސިލްތައް', profile: 'ޕްރޮފައިލް',
    settings: 'ސެޓިންގްސް', wapsign: 'ވެޕްސައިން',
    letters: 'ސިޓީ',
  },
  roles: {
    SYS_ADMIN: 'ސިސްޓަމް އެޑްމިން',
    USER: 'ޔޫޒަރު',
  } satisfies Record<Role, string>,
  orgAdminBadge: 'އެޑްމިން',
  orgs: {
    title: 'ކައުންސިލްތައް', create: 'އައު ކައުންސިލެއް', name: 'ކައުންސިލްގެ ނަން',
    contactEmail: 'ގުޅޭނެ އީމެއިލް', users: 'ޔޫޒަރުން', created: 'އުފެއްދި ތާރީޚު',
    inviteAdmin: 'އެޑްމިން އިންވައިޓްކުރޭ', adminRole: 'އެޑްމިންގެ މަގާމު',
    suspend: 'ސަސްޕެންޑްކުރޭ', activate: 'އެކްޓިވޭޓްކުރޭ',
    inviteSent: 'އިންވައިޓް އީމެއިލްކޮށްފި', empty: 'އަދި ކައުންސިލެއް ނެތް',
  },
  users: {
    title: 'ޔޫޒަރުން', invite: 'ޔޫޒަރެއް އިންވައިޓްކުރޭ', name: 'ނަން',
    role: 'މަގާމު', status: 'ހާލަތު', orgAdmin: 'އެޑްމިން ހުއްދަ',
    designationDv: 'މަޤާމު (ދިވެހި)', designationEn: 'މަޤާމު (އިނގިރޭސި)',
    editDesignation: 'މަޤާމު އެޑިޓްކުރޭ',
    deactivate: 'ޑީއެކްޓިވޭޓްކުރޭ', activate: 'އެކްޓިވޭޓްކުރޭ',
    pendingInvites: 'ފޮނުވާފައިވާ އިންވައިޓްތައް', revokeInvite: 'އިންވައިޓް ކެންސަލްކުރޭ',
    inviteSent: 'އިންވައިޓް އީމެއިލްކޮށްފި', expires: 'މުއްދަތު ހަމަވަނީ',
    empty: 'އަދި ޔޫޒަރެއް ނެތް',
    sendReset: 'ޕާސްވޯޑް ރީސެޓް ލިންކް ފޮނުވާ',
    resetShort: 'ޕާސްވޯޑް ރީސެޓް',
    resetSent: 'ރީސެޓް ލިންކް އީމެއިލްކޮށްފި',
    managedInOffice: 'ޔޫޒަރުން މެނޭޖްކުރަނީ ވެޕްލިފައި އޮފީހުގައި',
    managedInOfficeHint: 'ޔޫޒަރުން އިތުރުކުރުމާއި، މަގާމު ބަދަލުކުރުމާއި، އެކްޓިވޭޓް/ޑީއެކްޓިވޭޓްކުރުން ކުރެވޭނީ ވެޕްލިފައި އޮފީހުންނެވެ',
    passwordInOffice: 'ޕާސްވޯޑް ބަދަލުކުރަނީ ވެޕްލިފައި އޮފީހުގައި',
    passwordInOfficeHint: 'ޕާސްވޯޑް ބަދަލުކުރުމަށް ވެޕްލިފައި އޮފީސް ހުޅުވާ',
    openOffice: 'އޮފީސް ހުޅުވާ',
  },
  settings: {
    title: 'ސެޓިންގްސް',
    usersTab: 'ޔޫޒަރުން',
    orgTab: 'ކައުންސިލް',
    addressBookTab: 'އެޑްރެސް ފޮތް',
    headerImage: 'ޑޮކިއުމަންޓް ހެޑަރ',
    footerImage: 'ޑޮކިއުމަންޓް ފުޓަރ',
    footerText: 'ފުޓަރ ލިޔުން',
    uploadImage: 'ފޮޓޯއެއް އަޕްލޯޑްކުރޭ',
    removeImage: 'ފޮޓޯ ނަގާ',
    letterheadHint: 'މި ހެޑަރ އާއި ފުޓަރ ބޭނުންކުރެވޭނީ ޑޮކިއުމަންޓްތަކުގައެވެ',
    headerSizeHint: 'ރަނގަޅު ސައިޒް: 2048×410 ޕިކްސެލް · PNG ނުވަތަ JPEG · އެންމެ ބޮޑު 2MB',
    footerSizeHint: 'ރަނގަޅު ސައިޒް: 2048×270 ޕިކްސެލް · PNG ނުވަތަ JPEG · އެންމެ ބޮޑު 2MB',
    saved: 'ސޭވްކޮށްފި',
  },
  addressBook: {
    title: 'އެޑްރެސް ފޮތް',
    add: 'އައު އެޑްރެހެއް',
    edit: 'އެޑްރެސް އެޑިޓްކުރޭ',
    officeName: 'އޮފީސް / މުއައްސަސާގެ ނަން',
    addresseePerson: 'ސިޓީ ފޮނުވާ ފަރާތުގެ ނަން',
    address: 'އެޑްރެސް',
    atoll: 'އަތޮޅު',
    island: 'ރަށް',
    phone: 'ފޯނު ނަންބަރު',
    email: 'އީމެއިލް',
    empty: 'އަދި އެޑްރެހެއް ނެތް',
    deleteConfirm: 'މި އެޑްރެސް ޑިލީޓްކުރަން ބޭނުންތޯ؟',
    manualEntry: 'އަމިއްލައަށް ލިޔުއްވާ',
    pickFromBook: 'އެޑްރެސް ފޮތުން ހޮއްވަވާ',
    selectPlaceholder: 'އެޑްރެހެއް ހޮއްވަވާ…',
  },
  dashboard: {
    welcome: 'މަރުޙަބާ',
    comingSoon: 'ޑޮކިއުމަންޓް ފީޗާ ތައް ދާދި އަވަހަށް މި ތަނުން ލިބޭނެއެވެ.',
  },
  letters: {
    title: 'ސިޓީ',
    write: 'ސިޓީއެއް ލިޔުއްވާ',
    empty: 'އަދި ސިޓީއެއް ނެތް',
    draftPill: 'ޑްރާފްޓް',
    finalizedPill: 'ފައިނަލްކޮށްފައި',
    open: 'ހުޅުވާ',
    deleteConfirm: 'މި ސިޓީ ޑިލީޓްކުރަން ބޭނުންތޯ؟',
    subject: 'ސުރުޚީ',
    letterDate: 'ސިޓީގެ ތާރީޚު',
    letterNumber: 'ސިޓީ ނަންބަރު',
    addressTo: 'ފޮނުވާ ފަރާތް',
    referringLetter: 'ހަވާލާދޭ ސިޓީ',
    targetPages: 'ޞަފްޙާގެ އަދަދު (އަންދާޒާ)',
    signatoryName: 'ސޮއިކުރާ ފަރާތުގެ ނަން',
    signatoryDesignation: 'ސޮއިކުރާ ފަރާތުގެ މަގާމު',
    body: 'ސިޓީގެ ލިޔުން',
    bodyStandInHint: 'މިއީ ވަގުތީ ފީލްޑެކެވެ — ފުރިހަމަ އެޑިޓަރ ދެން އަންނަ ބައިގައި ލިބޭނެއެވެ',
    saving: 'ސޭވްވަނީ…',
    savedDraft: 'ޑްރާފްޓް ސޭވްވެއްޖެ',
    saveFailed: 'ސޭވެއް ނުވި',
    backToList: 'ސިޓީ ލިސްޓަށް',
    newTitle: 'އައު ސިޓީއެއް',
    // Body editor toolbar (Task 10)
    bold: 'ބޯލްޑް',
    underline: 'އަންޑަރލައިން',
    alignRight: 'ކަނާތްފަރާތަށް',
    alignCenter: 'މެދަށް',
    alignLeft: 'ވම ފަރާތަށް',
    alignJustify: 'ދެފަރާތަށް ހަމަކުރޭ',
    bulletList: 'ބުލެޓް ލިސްޓް',
    orderedList: 'ނަންބަރު ލިސްޓް',
    heading2: 'ސުރުޚީ 2',
    heading3: 'ސުރުޚީ 3',
    pageEstimate: 'ޞަފްޙާ: ~{n}',
    // Actions (Task 10)
    preview: 'ޕްރިވިއު',
    previewing: 'ޕްރިވިއު ހަދަނީ…',
    finalize: 'ފައިނަލްކުރޭ',
    finalizing: 'ފައިނަލްކުރަނީ…',
    finalizeConfirm: 'މި ސިޓީ ފައިނަލްކުރަން ބޭނުންތޯ؟ ފައިނަލްކުރުމަށްފަހު އެޑިޓްކުރެވޭނީ އަލުން ހުޅުވުމަށްފަހުއެވެ',
    finalizedNumber: 'ސިޓީ ނަންބަރު ދެވިއްޖެ',
    fitNotOk: 'އެންމެ ޞަފްޙާއަކަށް ނުފެތުނު',
    reopen: 'އަލުން ހުޅުވާ',
    reopening: 'ހުޅުވަނީ…',
    reopenConfirm: 'މި ސިޓީ އަލުން ހުޅުވަން ބޭނުންތޯ؟',
    downloadPdf: 'PDF ޑައުންލޯޑްކުރޭ',
    pdfNotReady: 'PDF އަދި ތައްޔާރެއް ނުވޭ',
  },
  notFound: { title: 'ޞަފްޙާ ނުފެނުނު', home: 'ފުރަތަމަ ޞަފްޙާއަށް' },
} as const;
